import { Injectable, ChangeDetectorRef } from '@angular/core';
import { Event, Router, NavigationEnd, ActivatedRoute, RouterEvent } from '@angular/router';
import { Subject } from 'rxjs';


import * as Stomp from '@stomp/stompjs';
import * as Sockjs from 'sockjs-client';
import { Frame, StompSubscription } from '@stomp/stompjs';
import { AlarmService } from './alarm.service';
import { AlarmGroupService } from './alarm-group.service';
import { AlarmMessage } from '../models/alarm-message';
import { PortService } from './port.service';
import { DeviceService } from './device.service';
import { Alarm } from '../models/alarm';
import { AlarmGroupCount } from '../models/AlarmGroup';
import { AuthenticationService } from '../shared/authentication.service';
import { IAsyncJobMessage } from '../models/async-job';
import { ReportJob } from '../models/report-job';

// Retry interval we attempt to connect Stomp again
const STOMP_RECONNECT_TIMEOUT = 30000;
/* so far no one makes changes across lines to states except for this guy, this keeps things managed... everyone else just peeks */

@Injectable({
  providedIn: 'root'
})
export class AlarmMessageService {

  siteId: string;

  user

  alarmMessages: AlarmMessage[] = [];

  changeSubject: Subject<number>; //string might be a bit more explicit
  siteAlarmSubject:Subject<number>;
  deviceAlarmSubject:Subject<number>;
  portAlarmSubject:Subject<number>;

  private stompRetryInterval = null;

  private _alarmReceived$: Subject<AlarmMessage> = new Subject<AlarmMessage>();
  public alarmsReceived$ = this._alarmReceived$.asObservable();

  // Shamefully abuse the alarm message service to indicate asyn jobs as well
  private _asyncJobReceived$: Subject<IAsyncJobMessage> = new Subject<IAsyncJobMessage>();
  public asyncJobReceived$ = this._asyncJobReceived$.asObservable();

  private _asyncReportJobReceived$: Subject<ReportJob> = new Subject<ReportJob>();
  public asyncReportJobReceived$ = this._asyncReportJobReceived$.asObservable();


  //have a dictionary here
  alarmMessageDict: Map<number, [AlarmMessage]> = new Map<number, [AlarmMessage]>();

  constructor(private router: Router,
    private route: ActivatedRoute,
    private alarmService: AlarmService,
    private alarmGroupService: AlarmGroupService,
    private portService: PortService,
    private deviceService: DeviceService,
    private authenticationService: AuthenticationService
  ) {
    //init stomp here    
    this.siteId = this.route.snapshot.paramMap.get('id') ? this.route.snapshot.paramMap.get('id') : null;
    this.router.events.subscribe((event: RouterEvent) => {
      //this.siteId =  this.route.parent.paramMap.subscribe
      if (event instanceof NavigationEnd) {
        console.log("alarm message service has been called", this.route.url)
      }
    })

    this.changeSubject = new Subject<number>();
    this.siteAlarmSubject = new Subject<number>();
    this.portAlarmSubject = new Subject<number>();
    this.deviceAlarmSubject = new Subject<number>();

    let activeSite: number = +localStorage.getItem("ACTIVESITE")

    //in case page is reloaded 
    if (this.alarmService.alarms.length == 0 || !this.alarmService.alarms)
      if (activeSite)
        this.alarmService.getAlarmsBySite(activeSite);


    this.authenticationService.authenticationInfo$.subscribe(authInfo => {
      if (authInfo.authenticated) {
        this.initAlarmSocket();
      } else {
        this.unsubscribeStompCient();
      }
    });
    console.log("active site", activeSite)
  }

  socket;
  stompClient;
  // List of subscribed Stomp ID's to unsubscribe
  private subscriptions: string[] = [];

  ngOnInit(): void {
    
  }


  //return observable when done
  alarmAcknowledged(alarm: Alarm) {
    if (this.stompClient) {
      this.stompClient.send("/rsm-nms/alarmMessageSubscriptionHandler", null, alarm)
    }
  }

  _removeAlarmFrom(alarm: Alarm, group: AlarmGroupCount) {
    this.alarmService.alarms.splice(this.alarmService.alarms.findIndex(elem => elem.alarm_id == alarm.alarm_id), 1); //remove
    this.alarmGroupService.alarmGroupCounts.find(elem => elem.alarm_group_id == alarm.alarm_id).alarm_count -= 1 //decrease count by one


    this.changeSubject.next(1); //2 is 

  }



  unsubscribeStompCient() {
    if (this.subscriptions) {
      this.subscriptions.forEach(id => {
        this.stompClient.unsubscribe(id);
      });
    }
    this.subscriptions = [];
  }

  initAlarmSocket() {
    //this.socket = new Sockjs('http://localhost:8090/notify-service/ws-notifications'); //port hardcoded for now, fix this asap
   
    this.socket = new Sockjs('/notify-service/ws-notifications');
    this.stompClient = Stomp.Stomp.over(this.socket);

    let that = this;
    this.stompClient.connect({}, function (frame: Frame) {
      if (that.stompRetryInterval != null) {
        clearInterval(that.stompRetryInterval);
        that.stompRetryInterval = null;
      }

      //that.stompClient.send("/rsm-nms/alarmMessageSubscriptionHandler", null, activeSite)

      that.user = JSON.parse(localStorage.getItem("USER")).id
      //should have privelleges to subscribe to alarm
      const subribeAlarms = that.stompClient.subscribe("/user/" +that.user+"/topic/alarms", (message: Frame) => {
        var alarmMessage: AlarmMessage = JSON.parse(message.body.toString());
        console.log("Received alarm ", alarmMessage);
        /* if an alarm message comes in, which port is concerned?  */
        that.alarmMessages.push(alarmMessage); //prob won't need this anymore       
        if(that.alarmMessageDict.has(alarmMessage.alarm.site.id))
          that.alarmMessageDict.get(alarmMessage.alarm.site.id).push(alarmMessage)
        else{
          that.alarmMessageDict.set(alarmMessage.alarm.site.id, [alarmMessage])
        }

        let alarmPending = Array<number>();
        if (that.alarmService.alarms.find(alarm => alarm.alarm_id == alarmMessage.alarm.alarm_id) == undefined) {
          //if alarm message is for an alarm on the current site, fetch alarm object from server then push into alarms 
          //array to update the view
          let currentSite = localStorage.getItem("ACTIVESITE")
          if (currentSite != null)
            if (alarmMessage.alarm.site.id == +currentSite.valueOf()) {
              // Add to list of pending alarms
              alarmPending.push(alarmMessage.alarm.alarm_id);
              that.alarmService.getAlarmByAlarmId(alarmMessage.alarm.alarm_id).subscribe(res => {
                if (res && res.length > 0) {
                  that.alarmService.alarms.push(res[0]);
                  let groupIndex = that.alarmGroupService.alarmGroupCounts.findIndex(elem => elem.alarm_group_id == res[0].alarm_group_id);
                  if (groupIndex >= 0) {
                    ++that.alarmGroupService.alarmGroupCounts[groupIndex].alarm_count;
                  } else {
                    console.log("Could not find group index for ", res[0].alarm_group_id)
                  }
                } else {
                  alarmPending.splice(alarmPending.indexOf(alarmMessage.alarm.alarm_id), 1)
                }
              });
            }

          //find and increase count by one, make this uniform... move the one in alarm-group-overview.comp into here
          // will blow up if not there, okay do this in 
          //++that.alarmGroupService.alarmGroupCounts[that.alarmGroupService.alarmGroupCounts.findIndex(elem => elem.alarm_group_id == validatedAlarm.alarm_group_id)].alarm_count;
          setTimeout(() => {
            that.changeSubject.next(1); //just say that something in the service has changed
          }, 500); //maybe switch this to promise

        }
        // that.alarmService.alarms.forEach(alarm => {

          // Alarm message updated/created
          if (alarmMessage.operation=="CREATED" || alarmMessage.operation=="UPDATED") {
            // Find the port, and refresh / find alarm, refresh, if can't find then insert
            let indexOfOffending: number = that.alarmService.alarms.findIndex(alarm => alarm.alarm_id == alarmMessage.alarm.alarm_id);
            if (indexOfOffending >= 0) {
              that.alarmService.getAlarmByAlarmId(alarmMessage.alarm.alarm_id).subscribe(res => {
                // If the alarm still exist we handle it
                if (res && res.length > 0) {
                  that.alarmService.alarms[indexOfOffending] = res[0]; //is first in array                  
                  setTimeout(() => {
                    that.changeSubject.next(1); //just say that something in the service has changed
                  }, 500);
                } else {
                  // Probably removed by someone else delete locally as well                  
                  let oldAlarm = that.alarmService.alarms.splice(indexOfOffending, 1);
                  if (oldAlarm && oldAlarm.length >= 0) {
                    --that.alarmGroupService.alarmGroupCounts[that.alarmGroupService.alarmGroupCounts.findIndex(elem => elem.alarm_group_id == oldAlarm[0].alarm_group_id)].alarm_count;
                  }
                  that.changeSubject.next(1);
                }              
              })
            } else {              
              if (alarmPending.indexOf(alarmMessage.alarm.alarm_id) < 0) {
                var indexUndefined = 0;
                do {
                  indexUndefined = that.alarmService.alarms.findIndex(alarm => !alarm);                  
                  if (indexUndefined >= 0) {
                    that.alarmService.alarms.splice(indexUndefined, 1)
                  }
                } while (indexUndefined >= 0);
              }              
            }          
            //same as above but for ports... find and refresh
          } else if (alarmMessage.operation=="DELETED") {
            // If we get a alarm deleted message remove the alarm from the list if it still exists in the list
            let indexOfOffending: number = that.alarmService.alarms.findIndex(alarm => alarm.alarm_id == alarmMessage.alarm.alarm_id);
            if (indexOfOffending >= 0) {
              let oldAlarm = that.alarmService.alarms.splice(indexOfOffending, 1);
                  if (oldAlarm && oldAlarm.length > 0) {
                    --that.alarmGroupService.alarmGroupCounts[that.alarmGroupService.alarmGroupCounts.findIndex(elem => elem.alarm_group_id == oldAlarm[0].alarm_group_id)].alarm_count;
                  }
                  that.changeSubject.next(1);
            }
          }
        // })

        switch (alarmMessage.alarm.alarm_type) {
          case 1:
          case 2:
          case 3:
            that.siteAlarmSubject.next(alarmMessage.alarm.site.id)
            break;
          case 21:
          case 22:
          case 23:
          case 24:
            that.deviceAlarmSubject.next(alarmMessage.alarm.dev_id)
            break;

          case 41:
          case 42:
            that.portAlarmSubject.next(alarmMessage.alarm.port_nid)
            break;

          default:
            break;
        }

        // Tell someone there was an alarm
        that._alarmReceived$.next(alarmMessage);


      }, {id:JSON.parse(localStorage.getItem("USER")).id}) //send username as an argument in headers... implement some sorting function of the server
      that.subscriptions.push(subribeAlarms.id);
      
      // The id needs to be different for each subscription otherwise it overrides
      const asyncResult = that.stompClient.subscribe(`/user/${that.user}/topic/async/job`, (message: Frame) => {
        let asyncJobMessage: IAsyncJobMessage = JSON.parse(message.body.toString());
        that._asyncJobReceived$.next(asyncJobMessage);
      }, {id:JSON.parse(localStorage.getItem("USER")).id + "-async-job"})
      that.subscriptions.push(asyncResult.id);

       // The id needs to be different for each subscription otherwise it overrides
       const asyncReportResult = that.stompClient.subscribe(`/user/${that.user}/topic/report/job`, (message: Frame) => {
        let msg: ReportJob = JSON.parse(message.body.toString());
        that._asyncReportJobReceived$.next(msg);
      }, {id:JSON.parse(localStorage.getItem("USER")).id + "-report-job"})
      that.subscriptions.push(asyncReportResult.id);
 
      // {id:JSON.parse(localStorage.getItem("USER")).id + "-async-job"}
    }, (error) => {
      console.log('Stomp error ', error);
    }, (close) => {
      // On close create interval reconnect if not already defined
      if (that.stompRetryInterval === null) {
        that.unsubscribeStompCient();
        that.stompRetryInterval = setInterval(() => {
          that.initAlarmSocket();
        }, STOMP_RECONNECT_TIMEOUT);
      }
    });
  }
}